import React, { useEffect, useState } from "react";
import { Button, Card, Flex, Image, Popover, Typography } from "antd";
import { DeleteOutlined, FileOutlined } from "@ant-design/icons";
import DateTimePicker from "../../common/DateTimePicker";
import apiInstance from "../../../services/apiService";
import { storageService } from "../../../services/storageService";
import ENDPOINTS from "../../../services/endpoint";
import AudioPlayer from "../../common/AudioPlayer";
import "./index.scss";

const { Text } = Typography;
interface ScheduleBubbleProps {
  date: string;
  time: string;
  phoneNumber: string;
  msg: any;
  onDelete?: (messageId: string) => void;
  previouslySelectedDate?: string | null;
  scrollToMessage?: (id: string) => void;
}

const ScheduleBubble: React.FC<ScheduleBubbleProps> = ({
  date,
  time,
  phoneNumber,
  msg,
  onDelete,
  previouslySelectedDate = null,
  scrollToMessage,
}) => {
  const [dateTimePickerOpen, setDateTimePickerOpen] = useState(false);
  const [scheduledDate, setScheduledDate] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const theme = storageService.getTheme() || "light";

  useEffect(() => {
    if (scheduledDate) {
      setLoading(true);
      const updateScheduledMsg = async () => {
        try {
          const response = await apiInstance.patch(
            ENDPOINTS.UPDATE_SCHEDULED_MSG,
            {
              id: msg?.id,
              newDate: scheduledDate,
            }
          );
        } catch (error) {
          console.error("Error updating scheduled message:", error);
        } finally {
          setLoading(false);
        }
      };

      updateScheduledMsg();
    }
  }, [msg?.id, scheduledDate]);

  return (
    <Card className="schedule-bubble">
      <Flex align="center" justify="space-between" gap={8}>
        <span className="header-text">
          Scheduled for {date}, {time}
        </span>
        <Popover
          content={
            <DateTimePicker
              onClose={() => setDateTimePickerOpen(false)}
              returnDateTime={setScheduledDate}
              previouslySelectedDate={previouslySelectedDate}
            />
          }
          trigger="click"
          open={dateTimePickerOpen}
          onOpenChange={setDateTimePickerOpen}
          placement="topLeft"
        >
          <Button
            className="open-btn"
            type="text"
            disabled={!msg.message}
            loading={loading}
            icon={
              <img
                src={`/assets/icons/${theme}/subscription.png`}
                width={20}
                height={20}
                alt="subscription"
              />
            }
          ></Button>
        </Popover>
      </Flex>

      <span className="phone-number">{phoneNumber}</span>

      <Flex align="center" justify="space-between" gap={8}>
        {msg.mediaType === 0 ? (
          <div className="bubble-message">
            <span className="message-text">{msg.message}</span>
          </div>
        ) : (
          <Flex vertical gap={6} className="w-full">
            {msg.replyMessage && (
              <div
                className="reply-parent"
                onClick={() => {
                  if (msg.replyToId && scrollToMessage) {
                    scrollToMessage(msg.replyToId);
                  }
                }}
                style={{
                  cursor: msg.replyToId ? "pointer" : "default",
                }}
              >
                <Text className="text">{msg.replyMessage || msg.filePath}</Text>
              </div>
            )}

            {msg.replyMediaType === 1 && msg.replyFilePath ? (
              <Image
                src={msg.replyFilePath}
                alt="chat image"
                // width={100}
                style={{
                  maxWidth: "100%",
                  maxHeight: "300px",
                  borderRadius: "8px",
                  objectFit: "cover",
                }}
              />
            ) : msg.replyMediaType === 4 && msg.replyFilePath ? (
              <AudioPlayer audioUrl={msg.replyFilePath} />
            ) : msg.replyMediaType === 3 && msg.replyFilePath ? (
              <Flex align="center" gap={10}>
                <FileOutlined className="file-icon" />
                <a
                  className="file-link"
                  href={msg.filePath}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open File
                </a>
              </Flex>
            ) : null}

            {msg.mediaType === 1 && msg.filePath ? (
              <Image
                src={msg.filePath}
                alt="chat image"
                style={{
                  maxWidth: "100%",
                  maxHeight: "300px",
                  borderRadius: "8px",
                  objectFit: "cover",
                }}
              />
            ) : msg.mediaType === 4 && msg.filePath ? (
              <AudioPlayer audioUrl={msg?.filePath} />
            ) : (msg.mediaType === 2 || msg.mediaType === 3) && msg.filePath ? (
              <div className="bubble-message">
                <Flex align="center" gap={10}>
                  <FileOutlined className="file-icon" />
                  <a
                    className="file-link"
                    href={msg.filePath}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open File
                  </a>
                </Flex>
              </div>
            ) : (
              <Text className="text-msg">{msg.message}</Text>
            )}
          </Flex>
        )}
        <DeleteOutlined
          className="delete-icon"
          onClick={() => onDelete && onDelete(msg.id)}
          disabled={loading}
        />
      </Flex>
    </Card>
  );
};

export default ScheduleBubble;
